import Login from "./modules/landing/Login";
import ForgotPassword from "./modules/landing/ResetPassword/ForgotPassword";
import Register from "./modules/landing/Register";
import PageNotFound from "./modules/PageNotFound";
import ResetPassword from "./modules/landing/ResetPassword/ResetPassword";
import RequestToken from "./modules/landing/ResetPassword/RequestToken";
import Dashboard from "./modules/home/Dashboard";
import Organizations from "./modules/organization/Organizations";
import CreateOrganization from "./modules/organization/CreateOrganization";
import Home from "./modules/home/Home";
import OrganizationProfile from "./modules/organization/OrganizationProfile";
import CreateVenue from "./modules/venues/CreateVenue";
import Venues from "./modules/venues/Venues";
import VenueDetails from "./modules/venues/VenueDetails";
import CreateAccessPoint from "./modules/aps/CreateAccesspoint";
import Accesspoint from "./modules/aps/AccessPointDetails";
import SplashPages from "./modules/splash_page/SplashPages";
import CreateSplashPage from "./modules/splash_page/CreateSplashPage";
import SplashPageDetails from "./modules/splash_page/SplashPageDetails";
import Customers from "./modules/customers/Customers";
import Connections from "./modules/connections/Connections";
import ProfileComponent from "./modules/profile/ProfileComponent";
import CustomerProfile from "./modules/customers/CustomerProfile";
import ServicePlans from "@/modules/servicePlans/ServicePlans";
import CreateServicePlan from "@/modules/servicePlans/CreateServicePlan";
import BandwidthPolicies from "@/modules/bandwidthPolicy/BandwidthPolicies";
import CreateBandwidthPolicy from "@/modules/bandwidthPolicy/CreateBandwidthPolicy";
import BandwidthPolicy from "@/modules/bandwidthPolicy/BandwidthPolicy";
import ServicePlan from "@/modules/servicePlans/ServicePlan";
import SelectOrganization from "@/modules/home/SelectOrganization";
import Vouchers from "@/modules/prepaid/Vouchers";
import Subscriptions from "@/modules/prepaid/Subscriptions";
import GenerateVouchers from "@/modules/prepaid/GenerateVouchers";
import ConnectToWifi from "@/customer/ConnectToWifi";
import AccessControl from "@/modules/organization/AccessControl";
import CustomerGroups from "@/modules/customers/Groups/CustomerGroups";
import GroupComponent from "@/modules/customers/Groups/GroupComponent";
import BroadcastsComponent from "@/modules/Broadcasts/BroadcastsComponent";
import BroadcastComponent from "@/modules/Broadcasts/BroadcastComponent";
import NewBroadcastMessageComponent from "@/modules/Broadcasts/NewBroadcastMessageComponent";
import ReportsComponents from "@/modules/reports/ReportsComponents";
import SurveysComponent from "@/modules/Survey/SurveysComponent";
import SurveyComponent from "@/modules/Survey/SurveyComponent";
import CreateSurvey from "@/modules/Survey/CreateSurvey";
import SurveyReport from "@/modules/Survey/SurveyReport";
import AdsDashboard from '@/modules/ads/AdsDashboard.vue'
import CreateAdCampaign from '@/modules/ads/CreateAdCampaign.vue'
import AdCampaignList from '@/modules/ads/AdCampaignList.vue'
import AdAnalytics from '@/modules/ads/AdAnalytics.vue'
import BannerList from "@/modules/ads/BannerList.vue";
import MpesaTransactions from '@/modules/prepaid/MpesaTransactions.vue'


 
const routes = [
    {path: '/connect', component: ConnectToWifi, name: 'connect'},
    {path: '/login', component: Login, name: 'login', meta: {guest: true}},
    {path: '/register', component: Register, name: 'register', meta: {guest: true}},
    {
        path: '/password/',
        component: ForgotPassword,
        meta: {guest: true},
        children: [{
            path: "forgot",
            component: RequestToken,
            name: 'password_forgot'
        }, {
            name: 'reset_password',
            path: "reset/:reset_token",
            component: ResetPassword,
            props: true,
        }]
    },
    {
        path: "/",
        component: Dashboard,
        props: true,
        meta: {requiresAuth: true},
        children: [
            {
                name: 'choose_org',
                path: "",
                component: SelectOrganization,
                props: true,
            },
            {
                name: 'profile',
                path: "/profile/:path?",
                component: ProfileComponent,
                props: true,
            },
            // Organizations
            {
                name: 'organizations',
                path: "/organizations",
                props: true,
                component: Organizations
            },
            {
                name: "create_organization",
                path: "/organizations/create",
                props: true,
                component: CreateOrganization
            },]
    },
    {
        path: "/:orgId",
        component: Dashboard,
        props: true,
        meta: {requiresAuth: true},
        children: [
            {
                name: "home",
                path: "",
                props: true,
                component: Home
            },
            {
                name: "organization",
                path: "settings/:path?",
                component: OrganizationProfile,
                props: true
            },
            {
                name: "access_control",
                path: "access_control/:path?/:id?",
                component: AccessControl,
                props: true
            },
            {
                name: "venues",
                path: "venues",
                props: true,
                component: Venues
            },
            {
                name: "create_venue",
                path: "venue/create",
                props: true,
                component: CreateVenue
            },
            {
                name: "venue_details",
                path: "venues/:venueId/:path?",
                component: VenueDetails,
                props: true
            },
            {
                name: "create_ap",
                path: "ap/create",
                props: true,
                component: CreateAccessPoint
            },
            {
                name: "access_point",
                path: "ap/:apId/:path?",
                props: true,
                component: Accesspoint
            },
            {
                name: "splash_pages",
                path: "splash_pages",
                props: true,
                component: SplashPages
            },
            {
                name: "create_splash_page",
                path: "splash_pages/create",
                props: true,
                component: CreateSplashPage
            },
            {
                name: "splash_page_details",
                path: "splash_pages/:pageId/:path?",
                props: true,
                component: SplashPageDetails
            },
            {
                name: "customers",
                path: "customers",
                props: true,
                component: Customers
            },
            {
                name: "customer_profile",
                path: "customers/:customerId/:path?",
                props: true,
                component: CustomerProfile
            },
            {
                name: "connections",
                path: "connections",
                props: true,
                component: Connections
            },
            {
                name: "groups",
                path: "groups",
                props: true,
                component: CustomerGroups
            },
            {
                name: "group",
                path: "groups/:id/:path?",
                props: true,
                component: GroupComponent
            },
            {
                name: "broadcasts",
                path: "broadcasts",
                props: true,
                component: BroadcastsComponent
            },
            {
                name: "broadcast",
                path: "broadcast/:id/:path?",
                props: true,
                component: BroadcastComponent
            },

            {
                name: "design_mail",
                path: "broadcasts/create",
                props: {breadcrumb: true, fullscreen: true},
                component: NewBroadcastMessageComponent
            },
            {
                name: "surveys",
                path: "surveys",
                props: true,
                component: SurveysComponent
            },
            { 
                name: "survey",
                path: "survey/:id",
                props: true,
                component: SurveyComponent
            },
            {
                name: "create_survey",
                path: "surveys/create",
                props: true,
                component: CreateSurvey
            },
            {
                name: "survey_report",
                path: "surveys/report",
                props: true,
                component: SurveyReport
            },
                  {
                name: "ads_dashboard",
                path: "ads",
                props: true,
                component: AdsDashboard
            },
            {
                name: "create_ad_campaign",
                path: "ads/create",
                props: true,
                component: CreateAdCampaign
            },
            {
                name: "ad_campaigns",
                path: "ads/campaigns",
                props: true,
                component: AdCampaignList
            },
            {
                name: "ad_analytics",
                path: "ads/analytics",
                props: true,
                component:AdAnalytics
            },
            {
            name: "banner_list",
            path: "ads/banners/:campaignId?",
            props: true,
            component: BannerList,
            },
            {
                name: "service_plans",
                path: "service_plans",
                props: true,
                component: ServicePlans
            },
            {
                name: "create_service_plan",
                path: "service_plans/new/:free?",
                props: true,
                component: CreateServicePlan
            },
            {
                name: "service_plan",
                path: "service_plan/:planId/:path?",
                props: true,
                component: ServicePlan
            },
            {
                name: "free_plan",
                path: "free_plan/:planId/:path?",
                props: true,
                component: ServicePlan
            },
            {
                name: "bandwidth_policies",
                path: "bandwidth_policies",
                props: true,
                component: BandwidthPolicies
            },
            {
                name: "new_bandwidth_policy",
                path: "bandwidth_policies/new",
                props: true,
                component: CreateBandwidthPolicy
            },
            {
                name: "bandwidth_policy",
                path: "bandwidth_policy/:policyId/:path?",
                props: true,
                component: BandwidthPolicy
            },
            {
                name: "vouchers",
                path: "vouchers",
                props: true,
                component: Vouchers
            },
            {
            name: "mpesa_transactions",
            path: "prepaid/mpesa-transactions",
            component: MpesaTransactions,
            },
            {
                name: "gen_vouchers",
                path: "vouchers/generate",
                props: true,
                component: GenerateVouchers
            },
            {
                name: "subscriptions",
                path: "subscriptions",
                props: true,
                component: Subscriptions
            },
            {
                name: "reports",
                path: "reports/:report?",
                props: true,
                component: ReportsComponents
            }
        ]
    },
    {path: "*", component: PageNotFound}
];

export default routes;